import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Text, Container } from '@boulevard/blvd-ui'
import { appRootStore } from '../stores'
import { Integration, AuthenticateButton, ModalComponent } from '../components'
import { autorun } from 'mobx'

export const Integrations: React.FC = observer(() => {
  const integrationsStore = appRootStore.getIntegrationsStore()
  useEffect(
    autorun(() => {
      integrationsStore.initAsync()
    })
  )

  return (
    <Container>
      <ModalComponent
            open={integrationsStore.getIsConfirmationOpen()}
            content={integrationsStore.getConfirmationText()}
            header="Confirmation"
            onYes={() => integrationsStore.uninstall()}
            onNo={() => integrationsStore.setIntegrationToDelete(undefined)}
      />
      <Text className="margin-b_15" theme="default" weight="bold" alignment="left" fontFamily="default" as="div" variant="size7">
                    Facebook & Instagram booking buttons
      </Text>

      <Text className="margin-b_20" theme="default" fontFamily="default" as="div">
            Click the button below to connect a social page. Then, follow the on-screen instructions to add the book now button.
      </Text>

      <AuthenticateButton/>

      {integrationsStore.hasBlvdFbIntegrations() &&
        <Text className="margin-b_15" theme="muted" weight="bold" alignment="left" fontFamily="default" as="div"
              variant="size5">
            Connected Pages
        </Text>
      }
      {integrationsStore.getBlvdFbIntegrations().map(x => <Integration
            key={`integration-${x.fbBlvdBusinessId}`} blvdFbIntegration={x}/>)}

    </Container>
  )
})
